export default function AgendaItemFollowupDirective() {
  return {
    template: require('./agendaItem-followup.html'),
    scope: {
      agendaItemId: '=',
      canDelete: '=',
      canEdit: '=',
      agendaItemFollowupDetail: '=',
      isInDialog: '='
    },
    controller: 'AgendaItemFollowupController',
    controllerAs: 'agendaItemFollowupVM',
    bindToController: true,
    replace: true
  };
}
